import { FC, SVGProps } from "react";

export const FreeShippingTruckSvg: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M2.71191 14.4168V5.75586H12.3349V16.3559H10.7749"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M12.8721 8.34584H18.2381C18.3965 8.34318 18.553 8.38078 18.6929 8.45511C18.8328 8.52944 18.9516 8.63808 19.0381 8.77084L21.1501 12.2418C21.265 12.4283 21.3263 12.6428 21.3271 12.8618V16.2068C21.3201 16.3121 21.2719 16.4103 21.1928 16.4802C21.1138 16.55 21.0104 16.5858 20.9051 16.5798H19.0391"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M8.0815 18.245C9.12753 18.245 9.9755 17.397 9.9755 16.351C9.9755 15.305 9.12753 14.457 8.0815 14.457C7.03547 14.457 6.1875 15.305 6.1875 16.351C6.1875 17.397 7.03547 18.245 8.0815 18.245Z"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M17.102 18.245C18.148 18.245 18.996 17.397 18.996 16.351C18.996 15.305 18.148 14.457 17.102 14.457C16.056 14.457 15.208 15.305 15.208 16.351C15.208 17.397 16.056 18.245 17.102 18.245Z"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </svg>
);
